var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.meta.blank)?_c('router-view'):(!_vm.$store.getters.isLoggedIn)?_c('guest'):_c('auth')
}
var staticRenderFns = []

export { render, staticRenderFns }